import { atom } from 'jotai';

export const referralsSearchAtom = atom('');

export const referralsSelectedSpecialtyAtom = atom('all');
export const referralsSelectedStatusAtom = atom('all');
export const referralsSelectedLocationAtom = atom('all');
export const referralsSelectedDateRangeAtom = atom('this_month');
export const referralsCustomDateRangeAtom = atom<any>(undefined);
export const referralsIsDatePickerOpenAtom = atom(false);
